<template lang="pug">
  main
    ModalCambiarPermisos(:config="modalConfig" :permisos="permisosToModal" :tipo="typePermisoToModal" v-show="modalStatus" @padre:select="changePermisos")
    NavBarUsuarios
    Loader(v-show="isLoading")
    section.hero(v-show="!isLoading")
      .container
        .columns.has-text-centered
          .column.is-12
            h3.title Permisos
            .columns
              .column.is-4
                .field
                  .control
                    input.input.is-primary(
                      type='text', 
                      placeholder='Buscar por Usario|Cargo',
                      v-model="filter",
                    )
              .column.is-1
                router-link.a.button.is-black.is-rounded(to="/Usuario/Permisos/Nuevo")
                  | Nuevo
            .columns
              Tb_Permisos(:permisos="permisosUsuarios" @showModal="ShowModal")
      .columns.column-blanco
</template>

<script>
  import NavBarUsuarios from '@/components/usuarios_Componentes/layout/NavBarUsuarios.vue'
  import Tb_Permisos from '@/components/usuarios_Componentes/Tb_Permisos.vue'
  import ModalCambiarPermisos from './componentes/ModalCambiarPermisos.vue'
  import Loader from '@/components/shared/Loader.vue'
  import usuariosServices from '../../services/usuarios/usuarios'

  export default {
    name: 'Permisos',
    components: { NavBarUsuarios, Loader, Tb_Permisos, ModalCambiarPermisos },
    data () {
      return {
        isLoading: true,
        filter: '',
        permisosUsuarios: [],
        permisos: [],
        permisosToModal: [],
        typePermisoToModal: '',
        modalConfig: {},
        modalStatus: false,
        permisosUsuarioSel: {},
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerPermisos_Usuarios()
      },
      obtenerPermisos_Usuarios() {
        usuariosServices.obtenerPermisos_Usuarios()
          .then( data => {
            this.permisosUsuarios = data.map(this.convetirPermisos_Usuario)
            this.obtenerPermisos()
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`,'ban', 'OK')
          })
      },
      convetirPermisos_Usuario(permiso) {
        return {
          ...permiso,
          id: parseInt(permiso.id),
          sca_tpa: parseInt(permiso.sca_tpa),
          sca_irge: parseInt(permiso.sca_irge),
          inventarios: parseInt(permiso.inventarios),
          monitoreo: parseInt(permiso.monitoreo),
          combustibles: parseInt(permiso.combustibles),
          tarjetas: parseInt(permiso.tarjetas),
          tags: parseInt(permiso.tags),
          vehiculos: parseInt(permiso.vehiculos),
          responsivas: parseInt(permiso.responsivas),
          requisiciones: parseInt(permiso.requisiciones),
          reportes: parseInt(permiso.reportes),
          facturas: parseInt(permiso.facturas),
          visitas: parseInt(permiso.visitas),
        }
      },

      obtenerPermisos () {
        usuariosServices.obtenerPermisos()
          .then( data => {
            const permisos_combustibles = data.permisos_combustibles.map(this.convetirPermisos)
            const permisos_inventarios = data.permisos_inventarios.map(this.convetirPermisos)
            const permisos_monitoreo = data.permisos_monitoreo.map(this.convetirPermisos)
            const permisos_reportes = data.permisos_reportes.map(this.convetirPermisos)
            const permisos_requisiciones = data.permisos_requisiciones.map(this.convetirPermisos)
            const permisos_responsivas = data.permisos_responsivas.map(this.convetirPermisos)
            const permisos_sca_irge = data.permisos_sca_irge.map(this.convetirPermisos)
            const permisos_sca_tpa = data.permisos_sca_tpa.map(this.convetirPermisos)
            const permisos_tags = data.permisos_tags.map(this.convetirPermisos)
            const permisos_tarjetas = data.permisos_tarjetas.map(this.convetirPermisos)
            const permisos_vehiculos = data.permisos_vehiculos.map(this.convetirPermisos)
            const permisos_facturas = data.permisos_facturas.map(this.convetirPermisos)
            const permisos_visitas = data.permisos_visitas.map(this.convetirPermisos)
            this.permisos = {
              permisos_combustibles,
              permisos_inventarios,
              permisos_monitoreo,
              permisos_reportes,
              permisos_requisiciones,
              permisos_responsivas,
              permisos_sca_irge,
              permisos_sca_tpa,
              permisos_tags,
              permisos_tarjetas,
              permisos_vehiculos,
              permisos_facturas,
              permisos_visitas,
            }
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`,'ban', 'OK')
          })
      },

      convetirPermisos (permiso) {
        return {
          ...permiso,
          id: parseInt(permiso.id)
        }
      },

      ShowModal (data) {
        this.permisosToModal = []
        this.modalConfig = {
          title: 'Cambiar Permisos',
          content: `Seleccione un permiso:`,
          classCancel: '',
          textCancel: 'Cancelar',
          classOk: 'is-black',
          textOk: 'Cambiar Permiso'
        }
        
        this.permisosUsuarioSel = data.data
        
        switch (data.permiso) {
          case 'permisos_sca_tpa':
            const { permisos_sca_tpa } = this.permisos
            this.permisosToModal = permisos_sca_tpa
            break
          case 'permisos_sca_irge':
            const { permisos_sca_irge } = this.permisos
            this.permisosToModal = permisos_sca_irge
            break
          case 'permisos_inventarios':
            const { permisos_inventarios } = this.permisos
            this.permisosToModal = permisos_inventarios
            break
          case 'permisos_responsivas':
            const { permisos_responsivas } = this.permisos
            this.permisosToModal = permisos_responsivas
            break
          case 'permisos_requisiciones':
            const { permisos_requisiciones } = this.permisos
            this.permisosToModal = permisos_requisiciones
            break
          case 'permisos_combustibles':
            const { permisos_combustibles } = this.permisos
            this.permisosToModal = permisos_combustibles
            break
          case 'permisos_tarjetas':
            const { permisos_tarjetas } = this.permisos
            this.permisosToModal = permisos_tarjetas
            break
          case 'permisos_tags':
            const { permisos_tags } = this.permisos
            this.permisosToModal = permisos_tags
            break
          case 'permisos_vehiculos':
            const { permisos_vehiculos } = this.permisos
            this.permisosToModal = permisos_vehiculos
            break
          case 'permisos_monitoreo':
            const { permisos_monitoreo } = this.permisos
            this.permisosToModal = permisos_monitoreo
            break
          case 'permisos_reportes':
            const { permisos_reportes } = this.permisos
            this.permisosToModal = permisos_reportes
            break
          case 'permisos_facturas':
            const { permisos_facturas } = this.permisos
            this.permisosToModal = permisos_facturas
            break
          case 'permisos_visitas':
            const { permisos_visitas } = this.permisos
            this.permisosToModal = permisos_visitas
            break
        }
        this.typePermisoToModal = data.permiso
        this.modalStatus = true
      },

      changePermisos (result) {
        this.isLoading = true
        this.modalStatus = false
        if (result.action) {
          usuariosServices.cambiarPermisos_User(this.permisosUsuarioSel.id, result.type, result.item.id)
            .then( data => {
              this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'OK')
              this.obtenerPermisos_Usuarios()
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast('bubble',`Error: ${e.message}`,'ban', 'OK')
            })
        } else {
          this.isLoading = false
        }
        this.permisosToModal = []
      },

      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>
  .container {
    padding: 40px 0;
  }
  .column-blanco {
    padding-bottom: 120px;
  }
</style>


// WEBPACK FOOTER //
// src/components/usuarios_Componentes/Permisos.vue